import { Component, EventEmitter, Input, Output } from '@angular/core';
import { V3InfoButton } from '../v3-info-button/v3-info-button';

@Component({
  selector: 'app-v3-tab-navigation',
  templateUrl: './v3-tab-navigation.html',
  styleUrl: './v3-tab-navigation.scss',
  standalone: true,
  imports: [V3InfoButton],
})
export class V3TabNavigation {
  @Input() activeTab = 'main';
  @Input() tabs: { label: string; id: string }[] = [];
  // finnetWeb desktop only — false (the default) for V3ZeroDesktopHeader's embedded usage,
  // which has no info button per the design.
  @Input() showInfoButton = false;
  @Output() tabChange = new EventEmitter<string>();
}
